import React from "react";
import UserName from "./UserName";
import SearchButton from "./SearchButton";
import NotificationButton from "./NotificationButton";
import './Header.css';


const Header = () => {

    return (
        <div className="header">
            <div className="group-container">
                <div className="overlap-group-2">
                    <div className="rectangle-5860"></div>
                    <div className="rectangle-5868"></div>
                </div>
                <div className="group-1000004695">
                    <div className="group-1000004518">
                        <SearchButton />
                        <NotificationButton />
                    </div>
                    <UserName />
                </div>
            </div>
        </div>
    )
}

export default Header;